<template>
    <div class="message" v-bind:class="getClassUser(message.user.id)">
        {{message.message}}<br>
        <div class="badge" v-bind:class="getClassUserBadge(message.user.id)">
            <small>
                <strong>{{"Dr. " + message.user.full_name}}</strong> {{ message.sent_at }}
            </small>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user_id', 'message'],
        methods:{
            getClassUser(messageUserId){
                if(messageUserId==this.user_id){
                    return 'ownMessage';
                }
            },
            getClassUserBadge(messageUserId){
                if(messageUserId==this.user_id){
                    return 'badge-success';
                } else {
                    return 'badge-secondary';
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.message {
    // padding-top: 1rem;
    margin: 2rem;
}

.ownMessage {
    text-align: right;
}
</style>